
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing, lifecycle } from 'recompose'
import Irrigations from './Irrigations'

const Component = compose(
  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.dispatch({
        type: 'SET_BREADCRUMB',
        items: [
          { page: 'Home', url: '/' },
          { page: 'Irrigações', url: '#' },
        ]
      })
    }
  }),
  branch(
    () => {
      return true
    },
    renderComponent(Irrigations),
    renderNothing
  )
)(Irrigations)

export default Component